import React from 'react';
import { Box, useTheme } from '@mui/material';

export const ErrorString = ({ text }) => {
  const theme = useTheme();
  return <Box sx={{ color: theme.palette.error.main }}>{text}</Box>;
};
